var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6196 0.990059C10.1296 0.500059 9.33957 0.500059 8.84957 0.990059L0.53957 9.30006C0.14957 9.69006 0.14957 10.3201 0.53957 10.7101L8.84957 19.0201C9.33957 19.5101 10.1296 19.5101 10.6196 19.0201C11.1096 18.5301 11.1096 17.7401 10.6196 17.2501L3.37957 10.0001L10.6296 2.75006C11.1096 2.27006 11.1096 1.47006 10.6196 0.990059Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.07b49aa575cf43c1a5cf37f08d00eb8c.svg";
export { ForwardRef as ReactComponent };